var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadImages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 28.15h21.45a.727.727 0 0 0 .6-1.2l-5.85-7.8a.75.75 0 0 0-1.2 0l-6 7.75-4.05-5.55a.75.75 0 0 0-1.2 0l-4.3 5.6a.815.815 0 0 0-.075.8.628.628 0 0 0 .625.4ZM3 36a2.878 2.878 0 0 1-2.1-.9A2.878 2.878 0 0 1 0 33V3A2.878 2.878 0 0 1 .9.9 2.878 2.878 0 0 1 3 0h30a2.878 2.878 0 0 1 2.1.9A2.878 2.878 0 0 1 36 3v30a3.076 3.076 0 0 1-3 3Zm0-3h30V3H3ZM3 3Z",
    fill: "#185edf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadImages);
export default __webpack_public_path__ + "static/media/DownloadImages.a8c7ef3c89f47226c9b825c014d4acb6.svg";
export { ForwardRef as ReactComponent };